import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", {
    class: "illustrationUserAccountBase col-md-4",
    style: { "background-image": "url('/images/checkout/checkoutSuccessDesktop.png')", "background-size": "cover" }
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        alt: "Vielen Dank für Deinen Kauf",
        class: "illustrationUserAccountMobile",
        src: "/images/checkout/checkoutSuccessMobile.png",
        style: { "width": "100%", "display": "none" }
    })
], -1);
const _hoisted_2 = { class: "col-md-8 p-sm-5 p-3" };
const _hoisted_3 = {
    key: 0,
    class: "registerContent"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", { class: "h3-responsive" }, "Nur ein Schritt zu Deinem Nutzerkonto", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", null, "Gib ein Passwort ein, um Deine Vorteile nicht zu verlieren:", -1);
const _hoisted_6 = { class: "mb-sm-5 mb-3" };
const _hoisted_7 = { class: "fc-brand_deep_blue strong" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "myPOINTS werden Dir mit der Auszahlung gutgeschrieben und können gegen Gutscheine eingetauscht werden",
    class: "strong font7 pointerhover"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon-ankaufbedingungen" })
], -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("li", null, "Schnelleres Abschließen von Bestellungen", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("li", null, "Überprüfung des Status Deiner Bestellungen", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("li", null, "Exklusive Gutscheincodes", -1);
const _hoisted_12 = { class: "mb-3" };
const _hoisted_13 = {
    class: "strong",
    style: { "word-break": "break-all" }
};
const _hoisted_14 = { class: "mb-sm-5 mb-3" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-lg-6" };
const _hoisted_17 = { class: "col-lg-6" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "font8-responsive fc-gray1" }, [
    /*#__PURE__*/ _createTextVNode(" Mit der Registrierung erklärst du dich mit den "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/agb",
        target: "_blank",
        title: "Allgemeinen Geschäftsbedingungen",
        class: "link-in-text"
    }, "AGB"),
    /*#__PURE__*/ _createTextVNode(" und "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/datenschutz",
        target: "_blank",
        title: "Datenschutz von mySWOOOP",
        class: "link-in-text"
    }, " Datenschutzbestimmungen "),
    /*#__PURE__*/ _createTextVNode(" der "),
    /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
    /*#__PURE__*/ _createTextVNode(" GmbH einverstanden. ")
], -1);
const _hoisted_19 = {
    key: 1,
    class: "successContent mt-3",
    style: { "min-height": "300px" }
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h2", { class: "h3-responsive" }, [
    /*#__PURE__*/ _createTextVNode(" Willkommen bei "),
    /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
    /*#__PURE__*/ _createTextVNode(" ! ")
], -1);
const _hoisted_21 = {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "",
    class: "strong font7",
    "data-original-title": "myPOINTS werden Dir gutgeschrieben und können gegen Gutscheine eingetauscht werden"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-ankaufbedingungen" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("a", {
    href: "/mein-account",
    class: "mb-sm-5 fc-green strong text-underline d-block"
}, "ZU MEINEM PROFIL", -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("a", {
    href: "/mein-account/transactions/purchases",
    class: "buttonGreen buttonBase d-inline-block"
}, " Status meiner Bestellung ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_password_input = _resolveComponent("base-password-input");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
            (!_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createElementVNode("ul", _hoisted_6, [
                        _createElementVNode("li", null, [
                            _createTextVNode(" Sammle "),
                            _createElementVNode("span", _hoisted_7, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.bonus_points), 1),
                                _createTextVNode(" myPOINTS "),
                                _hoisted_8
                            ]),
                            _createTextVNode(" , die Du mit dieser Bestellung verdient hast ")
                        ]),
                        _hoisted_9,
                        _hoisted_10,
                        _hoisted_11
                    ]),
                    _createElementVNode("p", _hoisted_12, [
                        _createTextVNode(" Dein Konto wird für die folgende E-Mail Adresse erstellt: "),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.customer_email), 1)
                    ]),
                    _createElementVNode("form", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_base_password_input, {
                                    id: "passwordInputField",
                                    name: "password",
                                    title: "Wähle Dein Passwort",
                                    modelValue: _ctx.password,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.password) = $event)),
                                    placeholder: "Wähle Dein Passwort"
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["buttonBase buttonGreen w-100 font6-responsive", _ctx.button_shake ? 'nope-shake' : '']),
                                    style: { "min-height": "48px" },
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)))
                                }, " Nutzerkonto erstellen ", 2)
                            ])
                        ])
                    ]),
                    _hoisted_18
                ]))
                : _createCommentVNode("", true),
            (_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("p", null, [
                        _createTextVNode(" Wir haben Dir "),
                        _createElementVNode("span", _hoisted_21, [
                            _createTextVNode(_toDisplayString(_ctx.bonus_points) + " myPOINTS ", 1),
                            _hoisted_22
                        ]),
                        _createTextVNode(" in Deinem Nutzerkonto hinterlegt. "),
                        _hoisted_23,
                        _createTextVNode(" Du verpasst ab sofort keine Deals und Aktionen mehr. ")
                    ]),
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26
                ]))
                : _createCommentVNode("", true)
        ])
    ], 64));
}
